export enum JobSortingEnum {
    New = "New",
    Old = "Old",
    SalaryDesc = "SalaryDesc",
    SalaryAsc = "SalaryAsc",
}